import "./sass/index.scss";

import { Tooltip, Toast, Popover, Modal } from "bootstrap";
import tippy from "tippy.js";
import fitvids from "fitvids";
import easy_background from "./vendor/easy_background.min.js";
// import { getSlider } from "simple-slider";

// getSlider();
// import "@mdi/font/css/materialdesignicons.css";

const app = {
  init() {
    this.cacheElements();
    this.registerListeners();
    this.makeTooltips();
    this.heroSlider();
    this.hideVideoAfterSeconds(11);
  },
  cacheElements() {
    this.$tooltipElements = document.querySelectorAll("[data-tooltip]");
    this.$bannerVideo = document.querySelector('.m-video-wrapper');
  },
  heroSlider() {
    if(!initSlider) return false;
    easy_background('#page-header', 
      {
        slide: sliderImages.slides,
        delay: sliderImages.delays
      }
    );
  },
  registerListeners() {},
  makeTooltips() {
    tippy("[data-tippy-content]", {
      theme: "light",
    });
  },
  hideVideoAfterSeconds(s) {
    if(!this.$bannerVideo) return false;
    window.setTimeout(() => {
      this.$bannerVideo.style.opacity = 1;
    }, 2000)

    window.setTimeout(() => {
      this.$bannerVideo.style.opacity = 0;
    }, s * 1000)

    window.setTimeout(() => {
      this.$bannerVideo.parentElement.removeChild(this.$bannerVideo);
    }, (s * 1000 + 1000))
  }
};

// init app
app.init();

fitvids({ ignore: '.m-video-wrapper iframe'});
